import { Component, OnInit, Input } from '@angular/core';
import { WidgetCountryDetailsDTO } from 'src/app/core/models/system/widget/widget-country-details.dto';

@Component({
  selector: 'app-country-details',
  templateUrl: './country-details.component.html',
  styleUrls: ['./country-details.component.scss']
})

export class CountryDetailsComponent implements OnInit {
  
  @Input() countryDetails: WidgetCountryDetailsDTO[] | undefined;

  constructor() { }

  public ngOnInit(): void { }
}
